import { useEffect, useRef } from "react"

export function useDemoSectionVisibility() {
  const sectionRef = useRef<HTMLElement>(null)

  useEffect(() => {
    const section = sectionRef.current
    if (!section) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return
        const isVisible = entry.isIntersecting

        // Dispatch custom event to notify background component
        window.dispatchEvent(
          new CustomEvent("landingDemoSectionVisible", {
            detail: { isVisible },
          }),
        )
      },
      {
        root: null,
        rootMargin: "-10% 0px -10% 0px", // Trigger when section is 10% visible
        threshold: 0.1,
      },
    )

    observer.observe(section)
    return () => observer.disconnect()
  }, [])

  return sectionRef
}
